import { Briefcase, Mail, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/ALLJsx/Navbar';
import Footer from '../../components/ALLJsx/Footer';
import '../AllCss/Careers.css';

function Careers() {
  return (
    <div className="Careers">
      <Navbar />
      {/* Hero Section */}
      <section className="Careers-hero">
        <div className="container">
          <h1 className="Careers-title">Careers at MyCarSlot</h1>
          <p className="Careers-subtitle">
            Join our team and help us deliver exceptional automotive experiences. We're always looking for talented people who share our passion for quality and customer service.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="Careers-content">
        <div className="container">
          <div className="Careers-card">
            <div className="Careers-card-icon">
              <Briefcase size={48} />
            </div>
            <h2 className="Careers-card-title">No Open Positions at This Time</h2>
            <p className="Careers-card-text">
              We don't have any job openings available right now. Please check back later—we update this page when new positions become available.
            </p>
            <p className="Careers-card-text Careers-card-text-secondary">
              Interested in working with us in the future? You can send us your resume and a short note via our contact page, and we'll keep it on file for when a role that matches your skills opens up.
            </p>
            <Link to="/contact" className="Careers-cta">
              <Mail size={20} />
              <span>Contact Us</span>
              <ArrowRight size={18} />
            </Link>
          </div>

          <div className="Careers-why">
            <h3 className="Careers-why-title">Why Work With Us</h3>
            <ul className="Careers-why-list">
              <li>Customer-focused culture and transparent pricing</li>
              <li>Quality pre-owned inventory and professional service</li>
              <li>Located in Ocean Springs, MS—a great place to work and live</li>
            </ul>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Careers;
